import { AutogenModelFourkitesControl, AutogenRowFourkitesControl } from "./autogen/AutogenModelFourkitesControl";

export class ModelFourkitesControl extends AutogenModelFourkitesControl<RowFourkitesControl> {
	constructor() {
		super(RowFourkitesControl);
	}
}

export class RowFourkitesControl extends AutogenRowFourkitesControl {
}